export const FileIdentifiersCapitalizationType = [
  {
    name: 'Carta de resgate',
    key: 'RESCUE_LETTER',
  },
  {
    name: 'Carta de resgate assinada',
    key: 'SIGNED_RESCUE_LETTER',
  },
  {
    name: 'Certificado',
    key: 'Certificate',
  },
  {
    name: 'Cláusula da seguradora',
    key: 'INSURER_CLAUSE',
  },
  {
    name: 'Comprovante de pagamento',
    key: 'PAYMENT_VOUCHER',
  },
  {
    name: 'Contrato de administração',
    key: 'ADMINISTRATOR_CONTRACT',
  },
  {
    name: 'Contrato de locação',
    key: 'LOCATION_CONTRACT',
  },
  {
    name: 'Documento administrador',
    key: 'ADMINISTRATOR_DOCUMENT',
  },
  {
    name: 'Documento locatário',
    key: 'TENANT_DOCUMENT',
  },
  {
    name: 'Icatu - boleto capitalização',
    key: 'BILL_ICATU',
  },
  {
    name: 'Icatu - condições capitalização',
    key: 'CONDITIONS_ICATU',
  },
  {
    name: 'Outros',
    key: 'OTHER',
  },
  {
    name: 'Porto Seguro - boleto capitalização',
    key: 'BILL_PORTO',
  },
  {
    name: 'Porto Seguro - condições capitalização',
    key: 'CONDITIONS_PORTO',
  },
  {
    name: 'Proposta',
    key: 'PROPOSAL',
  },
  {
    name: 'Proposta assinada',
    key: 'SIGNED_CONTRACT',
  }
];
